import { useEffect, useState } from "react";
import { Image } from "../../../Image/Image";
import { FicheType } from "../../FicheType/FicheType";
import { MoreInfo } from "../../MoreInfo/MoreInfo";

export const FicheTopsportEvent = (props) => {
  const [bodyItems, setBodyItems] = useState(null);
  //Processs body items
  useEffect(() => {
    let items = props.processFicheItems(props.data.body.items);
    setBodyItems(items);
  }, [JSON.stringify(props.data.body.items)]);

  return (
    <div className="c-fiche c-topsportevent-full" data-aos="fade-up">
      <div>
        <FicheType type={props.data.type}>
          <i class="fa-fw fa-fw fas fa-calendar-alt"></i>
        </FicheType>
        <div className="image" title="Meer over">
          <Image
            alt={props.data.title}
            src={props.data.image && props.data.image.url}
          />
        </div>
        <header className="c-fiche__header">
          <h2 className="title" title={props.title}>
            {props.data.title}
          </h2>
        </header>
        <div className="c-fiche__body">
          <ul>
            {bodyItems}
            {props.data.isClosedEvent && (
              <li className="leaf" key={"bodyItem_closed"}>
                <i class="fa-solid fa-door-closed"></i>
                <span>{props.dictionary.isClosedEvent}</span>
              </li>
            )}
          </ul>
        </div>
        {props.data.link && (
          <MoreInfo
            data={{ hasDetail: true }}
            url={props.data.link}
            cta={props.data.linkText}
            target={props.data.target}
          />
        )}
      </div>
    </div>
  );
};
